import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import apiUrl from '../../../../configs/constant';
import { useToast } from "../../../../components/ToastProvider";

interface FormInputs {
  nama: string;
  alamat: string;
}

interface AddSupplierDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void; // dipanggil setelah supplier berhasil ditambah
}

export default function AddSupplierDialog({ open, onClose, onSuccess }: AddSupplierDialogProps) {
    const { showToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<FormInputs>({ defaultValues: { nama: "", alamat: "" } });

  const onSubmit = async (form: FormInputs) => {
    try {
        const url = apiUrl.apiUrl + '/purchasing/supplier/add-dialog'
        axios
            .post(url, form, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    reset();
                    onClose();
                    if (onSuccess) onSuccess();
                    showToast("Berhasil menambahkan data","success");
                } else {
                    showToast("Gagal menambahkan supplier","error");
                }
            })
            .catch(error => {
                showToast("Gagal menambahkan supplier","error");
            })
    } catch (e) {
      showToast("Gagal menambahkan supplier","error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Tambah Supplier</DialogTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <TextField
            label="Nama Supplier"
            fullWidth
            margin="dense"
            {...register("nama", { required: true })}
            error={!!errors.nama}
            helperText={errors.nama && "Nama wajib diisi"}
          />

          <TextField
            label="Alamat Supplier"
            fullWidth
            margin="dense"
            {...register("alamat", { required: true })}
            error={!!errors.alamat}
            helperText={errors.alamat && "Alamat wajib diisi"}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Batal</Button>
          <Button type="submit" variant="contained">Simpan</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
